<template>
	<a target="_blank" rel="noopener noreferrer" :href="href">
		<slot />
	</a>
</template>

<script setup>
import BookingEngine from '@becurioushq/vips';

const { locale } = useI18n();

const props = defineProps({
	language: { type: String, default: '' },
	arrival: { type: String, default: '' },
	departure: { type: String, default: '' },
	pax: { type: Number, default: 2 },
	packageid: { type: String, default: '' },
	promotioncode: { type: String, default: '' },
	roomid: { type: String, default: '' },
});

const bookingEngine = new BookingEngine({
	hotelID: 'EB6A1D63-4588-47C2-B3B2-3D04A1D51F67',
});

const href = computed(() =>
	bookingEngine.getUrl({
		...props,
		language: props.language || locale.value,
	}),
);
</script>
<style lang="scss" scoped>
a {
	color: #fff;
	cursor: pointer;

	&:hover {
		text-decoration: none;
	}
}
</style>
